import {
    LOAD_CUSTOMER_INSIGHT_PROMOTION_NAMES
} from "../../../actions/types";

const INITIAL_STATE = []

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_CUSTOMER_INSIGHT_PROMOTION_NAMES:
            return [...action.payload]
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/restaurants/customerInsight/CustomerInsightPromotionNamesReducer.js